import VentaView from "./VentaView";
export default VentaView;